import type { StyleTag, RoomTag } from '../../types/project.types';
import { SHOP_BY_LOOK_LINK } from '../links';

const STYLE_MEDIA_PATH = '/mediabase/site/build.com/images/projects/styles/';

export enum SectionTitleEnum {
	MY_FAVORITES = 'My Favorites',
	FEATURED_LOOKS = 'Featured Looks',
	TRENDS_AND_INFLUENCES = 'Trends & Influences'
}

export const styleTags: StyleTag[] = [
	{
		name: 'Style',
		value: 'Traditional',
		viewAllUrl: `${SHOP_BY_LOOK_LINK}?style=Traditional`,
		image: `${STYLE_MEDIA_PATH}Traditional`
	},
	{
		name: 'Style',
		value: 'Organic Modern',
		viewAllUrl: `${SHOP_BY_LOOK_LINK}?style=Organic Modern`,
		image: `${STYLE_MEDIA_PATH}Organic Modern`
	},
	{
		name: 'Style',
		value: 'Rustic',
		viewAllUrl: `${SHOP_BY_LOOK_LINK}?style=Rustic`,
		image: `${STYLE_MEDIA_PATH}Rustic`
	},
	{
		name: 'Style',
		value: 'Farmhouse',
		viewAllUrl: `${SHOP_BY_LOOK_LINK}?style=Farmhouse`,
		image: `${STYLE_MEDIA_PATH}Farmhouse`
	},
	{
		name: 'Style',
		value: 'Mid-Century Modern',
		viewAllUrl: `${SHOP_BY_LOOK_LINK}?style=Mid-Century Modern`,
		image: `${STYLE_MEDIA_PATH}Mid-Century Modern`
	},
	{
		name: 'Style',
		value: 'Modern',
		viewAllUrl: `${SHOP_BY_LOOK_LINK}?style=Modern`,
		image: `${STYLE_MEDIA_PATH}Modern`
	},
	{
		name: 'Style',
		value: 'Industrial',
		viewAllUrl: `${SHOP_BY_LOOK_LINK}?style=Industrial`,
		image: `${STYLE_MEDIA_PATH}Industrial`
	},
	{
		name: 'Style',
		value: 'Transitional',
		viewAllUrl: `${SHOP_BY_LOOK_LINK}?style=Transitional`,
		image: `${STYLE_MEDIA_PATH}Transitional`
	},
	{
		name: 'Style',
		value: 'Coastal',
		viewAllUrl: `${SHOP_BY_LOOK_LINK}?style=Coastal`,
		image: `${STYLE_MEDIA_PATH}Coastal`
	},
	{
		name: 'Style',
		value: 'Luxe',
		viewAllUrl: `${SHOP_BY_LOOK_LINK}?style=Luxe`,
		image: `${STYLE_MEDIA_PATH}Luxe`
	}
];

export const roomTags: RoomTag[] = [
	{ name: 'Room', value: 'Kitchen', iconName: 'kitchen' },
	{ name: 'Room', value: 'Bathroom', iconName: 'bathroom' },
	{ name: 'Room', value: 'Living Room', iconName: 'living-room' },
	{ name: 'Room', value: 'Dining Room', iconName: 'dining-room' },
	{ name: 'Room', value: 'Bedroom', iconName: 'bedroom' },
	{ name: 'Room', value: 'Laundry', iconName: 'laundry-room' },
	{ name: 'Room', value: 'Office', iconName: 'office' },
	{ name: 'Room', value: 'Outdoor', iconName: 'outdoor' },
	{ name: 'Room', value: 'Lighting', iconName: 'kitchen_lighting' }
];

export const EMPTY_TAG_FILTER_SETS = { include: [] };
export const TWENTY_ONE_RESULTS = { page: 1, pageSize: 21 };
export const TRENDS_AND_INFLUENCES_TAG = { include: [{ name: 'featured', value: 'trends-and-influences' }] };
